module.exports = __webpack_public_path__ + "static/media/create-comment-disabled.310e04d6.svg";